import { faArrowDownWideShort } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Popover } from '@mui/material'
import useTranslation from 'next-translate/useTranslation'
import { useRef, useState } from 'react'
import { twMerge } from 'tailwind-merge'

import { KeyValuePair } from '@unreserved-frontend-v2/utils/types'

import { FilterChangeEvent } from '../schema-table/models'

export interface SortFilterProps {
  currentSort: string
  values: KeyValuePair<string>[]
  onChange: (event: FilterChangeEvent | FilterChangeEvent[]) => void
}

/**
 * @deprecated As this uses MUI
 */
export function SortFilter({ currentSort, values, onChange }: SortFilterProps) {
  const { t } = useTranslation()
  const [sortOpen, setSortOpen] = useState<boolean>(false)
  const sortBtn = useRef<HTMLButtonElement | null>(null)

  function handleSortClick() {
    setSortOpen(!sortOpen)
  }

  function handleSortClose() {
    setSortOpen(false)
  }

  function handleSortValueClick(value: string) {
    setSortOpen(false)
    onChange({ key: 'sort', value })
  }

  return (
    <>
      <button
        ref={sortBtn}
        data-testid="sort-btn"
        className="relative h-8 w-[35px] rounded border border-shades-600 bg-white"
        onClick={handleSortClick}
        aria-label={t('ui:sort-by')}
      >
        <FontAwesomeIcon icon={faArrowDownWideShort} />
      </button>

      <Popover
        id={'sort-popover'}
        open={sortOpen}
        anchorEl={sortBtn.current}
        onClose={handleSortClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <div className="my-2 py-1">
          {values.map((v, index) => {
            const item = twMerge(
              `hover:bg-shades-50 flex h-9 w-64 cursor-pointer items-center rounded-[5px] pl-2`,
              `${v.value === currentSort ? 'bg-shades-50' : ''}`,
              `${index !== values.length - 1 ? 'mb-1' : ''}`
            )
            return (
              <div className={item} key={v.key} onClick={() => handleSortValueClick(v.value)}>
                {t(v.key)}
              </div>
            )
          })}
        </div>
      </Popover>
    </>
  )
}

export default SortFilter
